import 'react-app-polyfill/ie11';
import 'core-js/es/weak-set';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.ends-with';
import 'core-js/modules/es.string.starts-with';
import 'core-js/modules/es.string.repeat';
import 'core-js/es/array';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/number';
import React, { useEffect } from 'react';

import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { unregister } from 'registerServiceWorker';
import TagManager from 'react-gtm-module';

import 'styles/app.scss';
import { enNZ } from 'tools/i18n/en-nz';

import { store, history } from 'store/main-reducer';
import { Preview } from 'views/pages/Preview/Preview';
import { ENVIRONMENT, ENVIRONMENTS_ENUM, APP_VERSION } from 'store/modules/app/constants';
import { ErrorPage } from 'views/pages/ErrorPage/ErrorPage';
import { Header } from 'views/components/Header/Header';
import { WorkItOut } from 'views/pages/SignUp/WorkItOut/WorkItOutController';
// import { Calculator } from 'views/pages/Calculator/Calculator';
import { PickAPlan } from 'views/pages/SignUp/PickAPlan/PickAPlanController';
import { ContactDetails } from 'views/pages/SignUp/ContactDetails/ContactDetailsController';
import { CompanyDetails } from 'views/pages/SignUp/CompanyDetails/CompanyDetailsController';
import { Payroll } from 'views/pages/SignUp/Payroll/PayrollController';
import { Summary } from 'views/pages/SignUp/Summary/SummaryController';
import { Footer } from 'views/components/Footer/Footer';
import { LoadOptions } from 'views/pages/LoadOptions/LoadOptionsController';
import { NextSteps } from 'views/pages/SignUp/NextSteps/NextStepsController';
import { getQueryStringParams } from 'tools/utilities/getQueryString';
import { actionSetDefaultPromoCode } from 'store/modules/sign-up/actions';
import { RenewToken } from 'views/components/RenewToken/RenewToken';
import { ReactComponent as SVGs } from './all.svg';

interface IQueryParams {
  promoCode?: string;
}

// Setup GoogleTagManager
const gtmId = process.env.REACT_APP_GTM_CODE;

if (gtmId) {
  TagManager.initialize({
    gtmId,
  });
}

const App = () => {
  useEffect(() => {
    const unListen = history.listen(() => {
      window.scrollTo(0, 0);
    });

    // Check the query params if any
    const queryParams: IQueryParams = getQueryStringParams(window.location.search);

    const { promoCode } = queryParams;
    if (promoCode) {
      store.dispatch(actionSetDefaultPromoCode(promoCode));
    }

    return () => unListen();
  }, []);

  return (
    <>
      <SVGs className="u-hidden" aria-hidden="true" />

      <Provider store={store}>
        <IntlProvider locale="en-NZ" messages={enNZ}>
          <Header />
          <RenewToken />

          <ConnectedRouter history={history}>
            <main>
              <Route
                render={({ location }) => (
                  <Switch location={location}>
                    {/* Flow routes @TODO could move these to a sub route? */}
                    <Route
                      exact
                      path="/"
                      component={LoadOptions}
                    />
                    <Route
                      exact
                      path="/sign-up/work-it-out"
                      component={WorkItOut}
                    />
                    <Route
                      exact
                      path="/sign-up/pick-a-plan"
                      component={PickAPlan}
                    />
                    <Route
                      exact
                      path="/sign-up/contact-details"
                      component={ContactDetails}
                    />
                    <Route
                      exact
                      path="/sign-up/company-details"
                      component={CompanyDetails}
                    />
                    <Route
                      exact
                      path="/sign-up/payroll-information"
                      component={Payroll}
                    />
                    <Route exact path="/sign-up/summary" component={Summary} />

                    <Route exact path="/sign-up/next-steps" component={NextSteps} />

                    {/* Calculator only page */}
                    {/* <Route path="/calculator" component={Calculator} /> */}

                    {ENVIRONMENT === ENVIRONMENTS_ENUM.DEV && (
                    <Route exact path="/preview" component={Preview} />
                    )}

                    {/* Handle page not found */}
                    <Route component={() => <ErrorPage is404 />} />
                  </Switch>
                )}
              />
            </main>
          </ConnectedRouter>

          <Footer version={APP_VERSION} />
        </IntlProvider>
      </Provider>
    </>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));

unregister();
